import Stack from '@mui/material/Stack';
import Box from '@mui/material/Stack';
import { ReactNode } from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { SxProps, Theme } from '@mui/material';
import { MUICreateAnimationTiming } from '../../../../utilitie/MUICreateAnimationTiming';

export interface IGroupPanelItemProps {
  children?: React.ReactElement | ReactNode,
  sx?: SxProps,
  active?: boolean,
  onClick:(...rest:any)=>any
}

export default function GroupPanelItem({ children, active, sx, ...other }: IGroupPanelItemProps) {

  return (
    <Stack component="li" pl={active ? 1 : 2} sx={{ ...(!active && { ':hover': { pl: 1 } }), transition: theme => MUICreateAnimationTiming(theme, 'padding'), ...sx }} {...other}>
      <Stack  direction={'row'} p={1} alignItems={'center'} bgcolor={active ? 'grey.400' : 'none'} sx={{ ...(!active && { ':hover': { bgcolor: 'grey.300' } }), transition: theme => MUICreateAnimationTiming(theme, 'backrgound'), borderTopLeftRadius: '1000px', borderBottomLeftRadius: '1000px', cursor: 'pointer' }}>
        <Stack direction={'row'} alignItems={'center'} spacing={1} sx={{ borderTopLeftRadius: '1000px', borderBottomLeftRadius: '1000px', cursor: 'pointer' }}>
          {children}
        </Stack>
        {active && (<ArrowForwardIosIcon sx={{ fontSize: '12px', ml: 'auto', transform: 'translateY(1px)' }} />)}
      </Stack>
    </Stack>
  );
}
